exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2[_v-7396641b]{font-family:Open Sans;font-size:30px;color:#6d6e71}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-7396641b&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Admin/Admin-login.vue
// module id = 442
// module chunks = 0